import { render } from "./AppBtn.vue?vue&type=template&id=2a3add37"
import script from "./AppBtn.vue?vue&type=script&lang=js"
export * from "./AppBtn.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__